import React, { FC, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { fetchData, getTranslatedValue, toasterrormsg } from '../../../reusable'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { Tr } from '../../../_metronic/i18n/Tr'
import { PageTitle } from '../../../_metronic/layout/core'
import Fancybox from '../Fancybox'
import { TourPackageDetailsHeader } from './TourPackageDetailsHeader'
import { useLang } from '../../../_metronic/i18n/Metronici18n'
const TourPackageOverview: FC = () => {

    const t = Tr()
    const lang = useLang()
    const navigate = useNavigate()
    const categoryId = sessionStorage.getItem('categoryId')
    useEffect(() => {
        if (categoryId != '5') {
            navigate('../dashboard/');
        }
    }, [categoryId])
    const location = useLocation();
    const tourpackageId = (location.state as any)?.tourpackageId || '';
    const [tourPackageDetails, setTourPackageDetails] = useState([]);
    const [qqsList, setQqsList] = useState([])

    // Tour Package Details api call
    const tourPackageDetailsApiCall = async () => {

        var param: any = {
            tourpackageId: tourpackageId,
        }
        var response: any = await fetchData("public/tourPackageDetails", param)

        if (response.status == "200") {
            setTourPackageDetails(response.data);
        }
        else {
            toasterrormsg(response.message)
        }
    }
    // for fancy box  
    const opts = {
        fullScreen: {
            autoStart: true, // Auto-start in full-screen mode
        },
        Thumbs: false,
        // Other options...
    };
    useEffect(() => {
        tourPackageDetailsApiCall()
    }, [tourpackageId])

    const qqsListApiCall = async () => {
        var response: any = await fetchData('public/qqsList', {})
        if (response.status == '200') {
            const filterData = response.data.map((item: any) => ({ label: item.name, value: item.qqsId }))
            setQqsList(filterData)
        } else {
            toasterrormsg(response.message)
        }
    }
    useEffect(() => {
        qqsListApiCall()
    }, [])
    return (
        <>
            <PageTitle breadcrumbs={[]}>{t('Tour Package Overview')}</PageTitle>
            <ToastContainer />
            <TourPackageDetailsHeader />
            {tourPackageDetails.map((tourPackage: any, index: any) => {
                var selectedQqs: any = qqsList.find((option: any) => option.value == tourPackage["qqs"]) || null

                return (
                    <div className='form' key={index}>
                        {/* <!--begin::Card--> */}
                        <div className='card'>
                            {/* <!--begin::Card header--> */}
                            <div className='card-header'>
                                {/* <!--begin::Card header--> */}
                                <div className='card-title fs-3 fw-bold'>{t('Basic Details')}</div>
                                {/* <!--end::Card header--> */}
                            </div>
                            {/* <!--end::Card header--> */}
                            {/* <!--begin::Card body--> */}
                            <div className='card-body'>
                                {tourPackage['en_agencyName'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Agency Name (English)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: tourPackage['en_agencyName'],
                                                            }}
                                                        ></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tourPackage['ru_agencyName'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Agency Name (Russian)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: tourPackage['ru_agencyName'],
                                                            }}
                                                        ></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tourPackage['uz_agencyName'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Agency Name (Uzbek)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: tourPackage['uz_agencyName'],
                                                            }}
                                                        ></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tourPackage['contact_person_name'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Contact Person Name')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: tourPackage['contact_person_name'],
                                                            }}
                                                        ></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tourPackage['email'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Email')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: tourPackage['email'],
                                                            }}
                                                        ></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tourPackage['phoneNo'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Mobile Number')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: tourPackage['phoneNo'],
                                                            }}
                                                        ></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}

                                {tourPackage['socialMediaChannels'] &&
                                    tourPackage['socialMediaChannels'].length > 0 && (
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Social Media Links')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className='fw-semibold text-gray-600 mt-3'>
                                                        {/* Render each social media type and link on a new line */}
                                                        {tourPackage['socialMediaChannels']
                                                            .filter(
                                                                (channel: any) =>
                                                                    channel['socialMediaType'] && channel['socialMediaLink']
                                                            ) // Filter out channels without type or link
                                                            .map((channel: any, index: number) => (
                                                                <p key={index}>
                                                                    <strong>{channel['socialMediaType']}:</strong>
                                                                    {'  '}
                                                                    <a
                                                                        href={channel['socialMediaLink']}
                                                                        target='_blank'
                                                                        rel='noopener noreferrer'
                                                                    >
                                                                        {channel['socialMediaLink']}
                                                                    </a>
                                                                </p>
                                                            ))}
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                    )}
                                <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                                    <div className='fs-3 fw-bold mb-5 '>{t('Property Location')}</div>
                                </div>

                                {tourPackage['location'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Location')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div>{tourPackage['location']} </div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}

                                {tourPackage['vendorDetails'] && tourPackage['vendorDetails'].map((vendordetail: any) => {
                                    return (
                                        <>
                                            {vendordetail['country'] && vendordetail['country'].map((country: any) => {
                                                return (
                                                    <>
                                                        {country['name'] ? (
                                                            <>
                                                                {/* <!--begin::Row--> */}
                                                                <div className='row mb-8'>
                                                                    {/* <!--begin::Col--> */}
                                                                    <div className='col-xl-3'>
                                                                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Country')}</div>
                                                                    </div>
                                                                    {/* <!--end::Col--> */}

                                                                    {/* <!--begin::Col--> */}
                                                                    <div className='col-xl-9'>
                                                                        {/* <!--begin::Progress--> */}
                                                                        <div className='d-flex flex-column'>
                                                                            <div className=' fw-semibold text-gray-600 mt-3'>
                                                                                <div>{country['name']}</div>
                                                                            </div>
                                                                        </div>
                                                                        {/* <!--end::Progress--> */}
                                                                    </div>
                                                                    {/* <!--end::Col--> */}
                                                                </div>
                                                                {/* <!--end::Row--> */}
                                                            </>
                                                        ) : (
                                                            ''
                                                        )}
                                                    </>
                                                )
                                            })}

                                            {vendordetail['addressline1'] ? (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Address Line 1')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div>{vendordetail['addressline1']}</div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            ) : (
                                                ''
                                            )}

                                            {vendordetail['addressline2'] ? (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Address Line 2')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div>{vendordetail['addressline2']}</div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            ) : (
                                                ''
                                            )}
                                            {vendordetail['region'] ? (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Region')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div>{getTranslatedValue(lang, vendordetail['regionDetail'][0], '_name')}</div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            ) : (
                                                ''
                                            )}
                                            {vendordetail['zipcode'] ? (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Zip Code')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div>{vendordetail['zipcode']}</div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            ) : (
                                                ''
                                            )}
                                        </>
                                    )
                                })}

                                {tourPackage['en_userGuide'] != '' ? (
                                    <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                                        <div className='fs-3 fw-bold mb-5 '>{t('Policies')}</div>
                                    </div>
                                ) : (
                                    ''
                                )}

                                {tourPackage['infactAge'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Infant Age')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: tourPackage['infactAge'],
                                                            }}
                                                        ></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tourPackage['childAge'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Child Age')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: tourPackage['childAge'],
                                                            }}
                                                        ></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tourPackage['adultAge'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Adult Age')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: tourPackage['adultAge'],
                                                            }}
                                                        ></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}

                                {tourPackage['en_highlight'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Highlight (English)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: tourPackage['en_highlight'],
                                                            }}
                                                        ></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tourPackage['ru_highlight'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Highlight (Russian)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: tourPackage['ru_highlight'],
                                                            }}
                                                        ></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}

                                {tourPackage['en_userGuide'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Guidelines (English)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: tourPackage['en_userGuide'],
                                                            }}
                                                        ></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tourPackage['ru_userGuide'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Guidelines (Russian)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: tourPackage['ru_userGuide'],
                                                            }}
                                                        ></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tourPackage['uz_userGuide'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Guidelines (Uzbek)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: tourPackage['uz_userGuide'],
                                                            }}
                                                        ></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tourPackage['en_cancellationPolicy'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Cancellation Policy (English)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: tourPackage['en_cancellationPolicy'],
                                                            }}
                                                        ></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tourPackage['ru_cancellationPolicy'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Cancellation Policy (Russian)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: tourPackage['ru_cancellationPolicy'],
                                                            }}
                                                        ></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tourPackage['uz_cancellationPolicy'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Cancellation Policy (Uzbek)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: tourPackage['uz_cancellationPolicy'],
                                                            }}
                                                        ></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}

                                {tourPackage['customPolicy'].length > 0 ? (
                                    <div className='col-xl-3 mb-5 mt-5'>
                                        <div className='fs-3 fw-bold mb-5 '>{t('Custom Policy')}</div>
                                    </div>
                                ) : (
                                    ''
                                )}

                                <div className='custom-docs-container'>
                                    {tourPackage['customPolicy'] &&
                                        tourPackage['customPolicy'].length > 0 &&
                                        tourPackage['customPolicy'].map((item: any, index: any) => {
                                            return (
                                                <div key={index} className='custom-docs-item'>
                                                    {item['en_title'] && (
                                                        <div className='custom-docs-block'>
                                                            <div className='col-xl-3'>
                                                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                                                    {t('Custom Policy English Title')}
                                                                </div>
                                                            </div>
                                                            <div className='col-xl-9'>
                                                                <div className='d-flex flex-column'>
                                                                    <div className='fw-semibold text-gray-600 mt-3'>
                                                                        <div dangerouslySetInnerHTML={{ __html: item['en_title'] }}></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {item['en_description'] && (
                                                        <div className='custom-docs-block'>
                                                            <div className='col-xl-3'>
                                                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                                                    {t('Custom Policy English Description')}
                                                                </div>
                                                            </div>
                                                            <div className='col-xl-9'>
                                                                <div className='d-flex flex-column'>
                                                                    <div className='fw-semibold text-gray-600 mt-3'>
                                                                        <div
                                                                            dangerouslySetInnerHTML={{ __html: item['en_description'] }}
                                                                        ></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {item['ru_title'] && (
                                                        <div className='custom-docs-block'>
                                                            <div className='col-xl-3'>
                                                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                                                    {t('Custom Policy Russian Title')}
                                                                </div>
                                                            </div>
                                                            <div className='col-xl-9'>
                                                                <div className='d-flex flex-column'>
                                                                    <div className='fw-semibold text-gray-600 mt-3'>
                                                                        <div dangerouslySetInnerHTML={{ __html: item['ru_title'] }}></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {item['ru_description'] && (
                                                        <div className='custom-docs-block'>
                                                            <div className='col-xl-3'>
                                                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                                                    {t('Custom Policy Russian Description')}
                                                                </div>
                                                            </div>
                                                            <div className='col-xl-9'>
                                                                <div className='d-flex flex-column'>
                                                                    <div className='fw-semibold text-gray-600 mt-3'>
                                                                        <div
                                                                            dangerouslySetInnerHTML={{ __html: item['ru_description'] }}
                                                                        ></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {item['uz_title'] && (
                                                        <div className='custom-docs-block'>
                                                            <div className='col-xl-3'>
                                                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                                                    {t('Custom Policy Uzbek Title')}
                                                                </div>
                                                            </div>
                                                            <div className='col-xl-9'>
                                                                <div className='d-flex flex-column'>
                                                                    <div className='fw-semibold text-gray-600 mt-3'>
                                                                        <div dangerouslySetInnerHTML={{ __html: item['uz_title'] }}></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {item['uz_description'] && (
                                                        <div className='custom-docs-block'>
                                                            <div className='col-xl-3'>
                                                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                                                    {t('Custom Policy Uzbek Description')}
                                                                </div>
                                                            </div>
                                                            <div className='col-xl-9'>
                                                                <div className='d-flex flex-column'>
                                                                    <div className='fw-semibold text-gray-600 mt-3'>
                                                                        <div
                                                                            dangerouslySetInnerHTML={{ __html: item['uz_description'] }}
                                                                        ></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            )
                                        })}
                                </div>

                                {tourPackage['ownerName'] != '' ? (
                                    <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                                        <div className='fs-3 fw-bold mb-5 '>{t('Finance & Legal Information')}</div>
                                    </div>
                                ) : (
                                    ''
                                )}

                                {tourPackage['ownerName'] && (
                                    <div className='row mb-8'>
                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-3'>
                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Owner Name')}</div>
                                        </div>
                                        {/* <!--end::Col--> */}

                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-9'>
                                            {/* <!--begin::Progress--> */}
                                            <div className='d-flex flex-column'>
                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: tourPackage['ownerName'],
                                                        }}
                                                    ></div>
                                                </div>
                                            </div>
                                            {/* <!--end::Progress--> */}
                                        </div>
                                        {/* <!--end::Col--> */}
                                    </div>
                                )}

                                {tourPackage['passportNumber'] && (
                                    <div className='row mb-8'>
                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-3'>
                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Passport Number')}</div>
                                        </div>
                                        {/* <!--end::Col--> */}

                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-9'>
                                            {/* <!--begin::Progress--> */}
                                            <div className='d-flex flex-column'>
                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: tourPackage['passportNumber'],
                                                        }}
                                                    ></div>
                                                </div>
                                            </div>
                                            {/* <!--end::Progress--> */}
                                        </div>
                                        {/* <!--end::Col--> */}
                                    </div>
                                )}

                                {tourPackage['jShShIR'] && (
                                    <div className='row mb-8'>
                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-3'>
                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('jShShIR')}</div>
                                        </div>
                                        {/* <!--end::Col--> */}

                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-9'>
                                            {/* <!--begin::Progress--> */}
                                            <div className='d-flex flex-column'>
                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: tourPackage['jShShIR'],
                                                        }}
                                                    ></div>
                                                </div>
                                            </div>
                                            {/* <!--end::Progress--> */}
                                        </div>
                                        {/* <!--end::Col--> */}
                                    </div>
                                )}
                                {tourPackage['businessName'] && (
                                    <div className='row mb-8'>
                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-3'>
                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Business Name')}</div>
                                        </div>
                                        {/* <!--end::Col--> */}

                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-9'>
                                            {/* <!--begin::Progress--> */}
                                            <div className='d-flex flex-column'>
                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: tourPackage['businessName'],
                                                        }}
                                                    ></div>
                                                </div>
                                            </div>
                                            {/* <!--end::Progress--> */}
                                        </div>
                                        {/* <!--end::Col--> */}
                                    </div>
                                )}
                                {tourPackage['businessSTIR'] && (
                                    <div className='row mb-8'>
                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-3'>
                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Business STIR')}</div>
                                        </div>
                                        {/* <!--end::Col--> */}

                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-9'>
                                            {/* <!--begin::Progress--> */}
                                            <div className='d-flex flex-column'>
                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: tourPackage['businessSTIR'],
                                                        }}
                                                    ></div>
                                                </div>
                                            </div>
                                            {/* <!--end::Progress--> */}
                                        </div>
                                        {/* <!--end::Col--> */}
                                    </div>
                                )}
                                {tourPackage['qqs'] && selectedQqs ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('QQS')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div dangerouslySetInnerHTML={{ __html: selectedQqs.label }}></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}

                                {tourPackage['mxikkodi'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('MXIK kodi')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div dangerouslySetInnerHTML={{ __html: tourPackage['mxikkodi'] }}></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tourPackage['oIchovBirligi'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t("O'Ichov Birligi")}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div dangerouslySetInnerHTML={{ __html: tourPackage['oIchovBirligi'] }}></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tourPackage['bankName'] && (
                                    <div className='row mb-8'>
                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-3'>
                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Bank Name')}</div>
                                        </div>
                                        {/* <!--end::Col--> */}

                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-9'>
                                            {/* <!--begin::Progress--> */}
                                            <div className='d-flex flex-column'>
                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: tourPackage['bankName'],
                                                        }}
                                                    ></div>
                                                </div>
                                            </div>
                                            {/* <!--end::Progress--> */}
                                        </div>
                                        {/* <!--end::Col--> */}
                                    </div>
                                )}
                                {tourPackage['branchName'] && (
                                    <div className='row mb-8'>
                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-3'>
                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Branch Name')}</div>
                                        </div>
                                        {/* <!--end::Col--> */}

                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-9'>
                                            {/* <!--begin::Progress--> */}
                                            <div className='d-flex flex-column'>
                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: tourPackage['branchName'],
                                                        }}
                                                    ></div>
                                                </div>
                                            </div>
                                            {/* <!--end::Progress--> */}
                                        </div>
                                        {/* <!--end::Col--> */}
                                    </div>
                                )}
                                {tourPackage['accountName'] && (
                                    <div className='row mb-8'>
                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-3'>
                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Account Name')}</div>
                                        </div>
                                        {/* <!--end::Col--> */}

                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-9'>
                                            {/* <!--begin::Progress--> */}
                                            <div className='d-flex flex-column'>
                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: tourPackage['accountName'],
                                                        }}
                                                    ></div>
                                                </div>
                                            </div>
                                            {/* <!--end::Progress--> */}
                                        </div>
                                        {/* <!--end::Col--> */}
                                    </div>
                                )}
                                {tourPackage['accountNumber'] && (
                                    <div className='row mb-8'>
                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-3'>
                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Account Nunber')}</div>
                                        </div>
                                        {/* <!--end::Col--> */}

                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-9'>
                                            {/* <!--begin::Progress--> */}
                                            <div className='d-flex flex-column'>
                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: tourPackage['accountNumber'],
                                                        }}
                                                    ></div>
                                                </div>
                                            </div>
                                            {/* <!--end::Progress--> */}
                                        </div>
                                        {/* <!--end::Col--> */}
                                    </div>
                                )}
                                {tourPackage['mfo'] && (
                                    <div className='row mb-8'>
                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-3'>
                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('MFO')}</div>
                                        </div>
                                        {/* <!--end::Col--> */}

                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-9'>
                                            {/* <!--begin::Progress--> */}
                                            <div className='d-flex flex-column'>
                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: tourPackage['mfo'],
                                                        }}
                                                    ></div>
                                                </div>
                                            </div>
                                            {/* <!--end::Progress--> */}
                                        </div>
                                        {/* <!--end::Col--> */}
                                    </div>
                                )}
                                {tourPackage['stir'] && (
                                    <div className='row mb-8'>
                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-3'>
                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('STIR')}</div>
                                        </div>
                                        {/* <!--end::Col--> */}

                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-9'>
                                            {/* <!--begin::Progress--> */}
                                            <div className='d-flex flex-column'>
                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: tourPackage['stir'],
                                                        }}
                                                    ></div>
                                                </div>
                                            </div>
                                            {/* <!--end::Progress--> */}
                                        </div>
                                        {/* <!--end::Col--> */}
                                    </div>
                                )}
                                <div className='row align-items-end h-100 gx-5 gx-xl-10'>
                                    {tourPackage['businessDocument'] != '' ? (
                                        <Fancybox options={opts}>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-md-4 mb-11 mb-md-0' key={index}>
                                                {/* <!--begin::Overlay--> */}
                                                <a
                                                    data-fancybox='gallery'
                                                    className='d-block overlay'
                                                    data-fslightbox='lightbox-hot-sales'
                                                    href={tourPackage['businessDocument']}
                                                >
                                                    <div
                                                        className='overlay-wrapper bgi-position-center bgi-no-repeat bgi-size-cover h-200px card-rounded mb-3'
                                                        style={{
                                                            height: '266px',
                                                            backgroundImage: `url('${tourPackage['businessDocument']}')`,
                                                        }}
                                                    ></div>
                                                    {/* <!--end::Image--> */}

                                                    {/* <!--begin::Action--> */}
                                                    <div className='overlay-layer card-rounded bg-dark bg-opacity-25'>
                                                        <i className='ki-outline ki-eye fs-3x text-white'></i>{' '}
                                                    </div>
                                                    {/* <!--end::Action--> */}
                                                </a>
                                                {/* <!--end::Overlay-->*/}
                                            </div>
                                            {/* <!--end::Col-->*/}
                                        </Fancybox>
                                    ) : (
                                        ''
                                    )}

                                    {tourPackage['idProofDocument'] != '' ? (
                                        <Fancybox options={opts}>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-md-4 mb-11 mb-md-0' key={index}>
                                                {/* <!--begin::Overlay--> */}
                                                <a
                                                    data-fancybox='gallery'
                                                    className='d-block overlay'
                                                    data-fslightbox='lightbox-hot-sales'
                                                    href={tourPackage['idProofDocument']}
                                                >

                                                    <div
                                                        className='overlay-wrapper bgi-position-center bgi-no-repeat bgi-size-cover h-200px card-rounded mb-3'
                                                        style={{
                                                            height: '266px',
                                                            backgroundImage: `url('${tourPackage['idProofDocument']}')`,
                                                        }}
                                                    ></div>
                                                    {/* <!--end::Image--> */}
                                                    {/* <!--begin::Action--> */}
                                                    <div className='overlay-layer card-rounded bg-dark bg-opacity-25'>
                                                        <i className='ki-outline ki-eye fs-3x text-white'></i>{' '}
                                                    </div>
                                                    {/* <!--end::Action-->       */}
                                                </a>
                                                {/* <!--end::Overlay-->          */}
                                            </div>
                                            {/* <!--end::Col-->      */}
                                        </Fancybox>
                                    ) : (
                                        ''
                                    )}
                                </div>
                                <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                                    <div className='fs-3 fw-bold mb-5 '>{t('Tour Package Images')}</div>
                                </div>

                                {tourPackage['images'] && tourPackage['images'].length != 0 ? (
                                    <div className='col-xl-12'>
                                        {/* <!--begin::Engage widget 7--> */}
                                        <div className='card card-flush h-xl-100'>
                                            <div className='pt-7'>
                                                <div className='row align-items-end h-100 gx-5 gx-xl-10'>
                                                    {tourPackage['images'].map((images: any, index: any) => {
                                                        return (
                                                            <>
                                                                <Fancybox options={opts}>
                                                                    {/* <!--begin::Col--> */}
                                                                    <div className='col-md-4 mb-11 mb-md-0' key={index}>
                                                                        {/* <!--begin::Overlay--> */}
                                                                        <a
                                                                            data-fancybox='gallery'
                                                                            className='d-block overlay'
                                                                            data-fslightbox='lightbox-hot-sales'
                                                                            href={images['mediaPath']}
                                                                        >
                                                                            <div
                                                                                className='overlay-wrapper bgi-position-center bgi-no-repeat bgi-size-cover h-200px card-rounded mb-3'
                                                                                style={{
                                                                                    height: '266px',
                                                                                    backgroundImage: `url('${images['mediaPath']}')`,
                                                                                }}
                                                                            ></div>
                                                                            {/* <!--end::Image--> */}

                                                                            {/* <!--begin::Action--> */}
                                                                            <div className='overlay-layer card-rounded bg-dark bg-opacity-25'>
                                                                                <i className='ki-outline ki-eye fs-3x text-white'></i>{' '}
                                                                            </div>
                                                                            {/* <!--end::Action-->       */}
                                                                        </a>
                                                                        {/* <!--end::Overlay-->          */}
                                                                    </div>
                                                                    {/* <!--end::Col-->      */}
                                                                </Fancybox>
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                                {/* <!--end::Row--> */}
                                            </div>
                                            {/* <!--end::Card body--> */}
                                        </div>
                                        {/* <!--end::Engage widget 7--> */}
                                    </div>
                                ) : (
                                    <div className='col-xl-12'>
                                        {/* <!--begin::Engage widget 1--> */}
                                        <div className='card h-md-100' dir='ltr'>
                                            {/* <!--begin::Body--> */}
                                            <div className='card-body d-flex flex-column flex-center'>
                                                {/* <!--begin::Heading--> */}
                                                <div className='mb-2'>
                                                    {/* <!--begin::Illustration--> */}
                                                    <div className='py-10 text-center'>
                                                        <img
                                                            src={toAbsoluteUrl('/media/svg/illustrations/easy/2.svg')}
                                                            className='theme-light-show h-125px'
                                                            alt=''
                                                        />
                                                        <img
                                                            src={toAbsoluteUrl('/media/svg/illustrations/easy/2-dark.svg')}
                                                            className='theme-dark-show h-125px'
                                                            alt=''
                                                        />
                                                    </div>
                                                    {/* <!--end::Illustration--> */}
                                                </div>
                                                {/* <!--end::Heading--> */}
                                            </div>
                                            {/* <!--end::Body--> */}
                                        </div>
                                        {/* <!--end::Engage widget 1--> */}
                                    </div>
                                )}
                            </div>

                        </div>
                        {/* <!--end::Card--> */}
                    </div>
                )
            })}
        </>
    )
}

export { TourPackageOverview }